/**
 * Payment logos shown on product pages, sticky bar, shop, mini cart, order overview and footer.
 * Switch a method to `true` ONLY after it is verified as active in Stripe.
 */
export const PAYMENT_METHOD_FLAGS = {
  visa: false,
  mastercard: true,
  apple_pay: true,
  google_pay: true,
  paypal: false,
  klarna: true,
} as const;

export type PaymentMethodId = keyof typeof PAYMENT_METHOD_FLAGS;

export const ACTIVE_PAYMENT_METHODS = (Object.keys(PAYMENT_METHOD_FLAGS) as PaymentMethodId[]).filter(
  (m) => PAYMENT_METHOD_FLAGS[m],
);

/** Spoken list of payment methods for FAQ/terms copy ({payMethods}); follows the PayPal flag. */
export const paymentMethodsText = (list: { withPaypal: string; withoutPaypal: string }): string =>
  PAYMENT_METHOD_FLAGS.paypal ? list.withPaypal : list.withoutPaypal;
